export default __webpack_public_path__ + "static/media/eline.09f34144.png";